// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f7bbb28","239":"17d46111","453":"47573ca6","667":"b15e892b"}[chunkId] + ".chunk.js";
};